import { Button, FormControl, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField } from "@mui/material";
import { authData, withAdminAuth } from "../../../components/GetAuth";
import TablePaginationComponent from "../../../components/TablePagination";
import styles from "./usertrackingreports.module.css";
import { StyledMainTableCell, StyledMainTableRow } from "../../../components/TableComponent";
import { Calendar, Home, Search } from "react-feather";
import { DateRangePicker } from "rsuite";
import { Close } from "@mui/icons-material";
import { TableLoader } from "../../../components/ContentLoader";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import axios from "axios";

const UserTrackingReports = () => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [allData, setAllData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [searchKey, setSearchKey] = useState('');
    const [filterType, setFilterType] = useState('');
    const [filterDate, setFilterDate] = useState(null);
    const [contentLoading, setContentLoading] = useState(true);

    const paginationChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const paginationChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }

    useEffect(() => {
        fetchOrders();
    }, [page, rowsPerPage]);

    useEffect(() => {
        if (page === 0) {
            fetchOrders();
        } else {
            setPage(0);
        }
    }, [searchKey, filterDate, filterType]);

    const fetchOrders = () => {
        axios.get(process.env.REACT_APP_API_URL + "v1/report/user-trackings", {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`,
            },
            params: {
                page: page + 1,
                per_page: rowsPerPage,
                search: searchKey,
                type: filterType,
                start_date: filterDate ? dayjs(filterDate[0]).format("YYYY-MM-DD") : null,
                end_date: filterDate ? dayjs(filterDate[1]).format("YYYY-MM-DD") : null,
            }
        }).then((response) => {
            setContentLoading(false);

            setAllData(response.data.data.data);
            setTotalCount(response.data.data.total);
        }).catch(() => {
            setContentLoading(false);
        });
    }

    return (<>
        <div className={`${styles.MainDiv}`}>
            <div className={`${styles.MainCard}`}>
                {contentLoading && <TableLoader />}

                {!contentLoading && (<div className={`${styles.PageTitleWrap}`}>
                    <p className={`${styles.PageTitle}`}>User Tracking Reports</p>
                    <nav aria-label="breadcrumb">
                        <ol className={`${styles.breadcrumb}`}>
                            <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Reports</li>
                            <li className={`${styles.breadcrumbItem} ${styles.active}`}>User Tracking Reports</li>
                        </ol>
                    </nav>
                </div>)}
                {!contentLoading && (<>
                    <div className={`${styles.TableFilterHead}`}>
                        <div className={`${styles.DataTableSearch}`}>
                            <Search className={`${styles.SearchIcon}`} />
                            <TextField id="search" type="text" placeholder="Search" aria-label="Search Input" value={searchKey} onChange={(e) => setSearchKey(e.target.value)} />
                            {searchKey !== "" && (<Button type="button" className={`${styles.CloseBU}`} onClick={(e) => setSearchKey("")}><Close /></Button>)}
                        </div>
                        <div className={`${styles.TableFilterBUSec}`}>
                            <div className={`${styles.FilterCard} ${styles.Select}`}>
                                <FormControl fullWidth>
                                    <InputLabel>Filter By Type</InputLabel>
                                    <Select value={filterType} label="Filter By Type" onChange={(e) => setFilterType(e.target.value)}>
                                        <MenuItem value={"all"}>All</MenuItem>
                                        <MenuItem value={'driver'}>Driver</MenuItem>
                                        <MenuItem value={'customer'}>Customer</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>

                            <div className={`${styles.FilterCard} Filter`}>
                                <div className={`${styles.DashFilterSec} DashFilterSec`}>
                                    <DateRangePicker format={"dd/MM/yyyy"} placement={"bottomEnd"} placeholder="Search by date" caretAs={Calendar} value={filterDate} showOneCalendar onChange={(e) => setFilterDate(e)} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={`${styles.CusTable}`}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <StyledMainTableCell>Name</StyledMainTableCell>
                                        <StyledMainTableCell>User Type</StyledMainTableCell>
                                        <StyledMainTableCell>Session Id</StyledMainTableCell>
                                        <StyledMainTableCell>User Type</StyledMainTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {allData.map((item, index) => {
                                        return (<StyledMainTableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                            <TableCell component="th" scope="row">{item?.name}</TableCell>
                                            <TableCell component="th" scope="row">{item?.user_type_name}</TableCell>
                                            <TableCell component="th" scope="row">{item?.session_id}</TableCell>
                                            <TableCell component="th" scope="row">{dayjs(item?.created_at).format('DD/MM/YYYY hh:mmA')}</TableCell>
                                        </StyledMainTableRow>);
                                    })}

                                    {allData.length === 0 && (<TableRow>
                                        <TableCell colSpan={6} align="center">No data found</TableCell>
                                    </TableRow>)}

                                </TableBody>
                                {totalCount > 0 && (<TableFooter>
                                    <TableRow>
                                        <TablePaginationComponent
                                            count={totalCount}
                                            colSpan={6}
                                            page={page}
                                            rowsPerPage={rowsPerPage}
                                            handleChangePage={paginationChangePage}
                                            handleChangeRowsPerPage={paginationChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                                )}
                            </Table>
                        </TableContainer>
                    </div>
                </>)}
            </div>
        </div>
    </>);
}

export default withAdminAuth(UserTrackingReports);